
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/options/[slug]",
      function () {
        return require("private-next-pages/docs/options/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/options/[slug]"])
      });
    }
  